export function fallbackTemplate() {
  return `
    <div class="container not-found">
      <div class="not-found__icon"></div>
      <p class="not-found__title">No Licenses Found</p>
      <p class="not-found__description">There are currently no licenses to display. Please check back later.</p>
    </div>
  `;
}
